import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AudienciaRoutingModule } from './audiencia-routing.module';
import { ListaComponent } from './lista/lista.component';
import { NovoComponent } from './novo/novo.component';
import { DetalhesComponent } from './detalhes/detalhes.component';
import {ComponentesModule} from "../../../core/componentes/componentes.module";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {NgSelectModule} from "@ng-select/ng-select";
import {NgxPaginationModule} from "ngx-pagination";
import {AngularEditorModule} from "@kolkov/angular-editor";
import {NgxMaskDirective} from "ngx-mask";


@NgModule({
  declarations: [
    ListaComponent,
    NovoComponent,
    DetalhesComponent
  ],
  exports: [
    NovoComponent
  ],
    imports: [
        CommonModule,
        AudienciaRoutingModule,
        ComponentesModule,
        ReactiveFormsModule,
        NgSelectModule,
        FormsModule,
        NgxPaginationModule,
        AngularEditorModule,
        NgxMaskDirective,
    ]
})
export class AudienciaModule { }
